import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import {
  SPRITE_CONFIG_TOKEN,
  SpriteConfig,
} from './model/sprite-config.interface';
import { SvgSpriteComponent } from './svg-sprite.component';
import { SvgSpriteService } from './svg-sprite.service';

/**
 * Module for svg sprite for using from svg-icon
 */
@NgModule({
  imports: [CommonModule],
  declarations: [SvgSpriteComponent],
  exports: [SvgSpriteComponent],
})
export class SvgSpriteModule {
  static forRoot(config: SpriteConfig): ModuleWithProviders<SvgSpriteModule> {
    return {
      ngModule: SvgSpriteModule,
      providers: [
        SvgSpriteService,
        {
          provide: SPRITE_CONFIG_TOKEN,
          useValue: config,
        },
      ],
    };
  }
}
